import { TbTrash } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const TrashIcon = (props: IconProps) => {
  return <IconBase icon={TbTrash} {...props} />;
};
